import { ESRD, HH, OPPS, PFS, SNF, FQHC } from "../../../Constants/modelTypes";
import { formatStringAsCurrency, formatStringWithPrecision } from "../../../Utils/stringUtils";

export default function ServiceLineItems(props) {
    if (props.model === OPPS) {
        return (<>
        <h4>Service Line Items</h4>
        <div className="table-responsive line-items">
            <table className="table">
                <thead>
                    <tr>
                        <td>Line ID</td>
                        <td>Revenue Code</td>
                        <td>Procedure Code<br/>(CPT / HCPCS)</td>
                        <td>Modifier 1</td>
                        <td>Modifier 2</td>
                        <td>Service Date</td>
                        <td>Units</td>
                        <td>Adjusted Units</td>
                        <td>Billed</td>
                        <td>Service Description</td>
                        <td>Allowed Prior to Lesser of Billed</td>
                        <td>Medicare Allowed</td>
                        <td>Payment Source</td>
                        <td>Final APC</td>
                        <td>APC Status Indicator</td>
                        <td>Bundled Flag</td>
                        <td>Modifier Adjustment</td>
                        <td>Multiple Surgery Adjustment</td>
                        <td>Manual Adjudication Flag</td>
                        <td>Error Flag</td>
                        <td>Error Description</td>
                        <td>Warning Flag</td>
                        <td style={{ minWidth: '175px' }}>Warning Description</td>
                    </tr>
                </thead>
                <tbody>
                    {props.result.services && props.result.services.map((s, i) => {
                        const matchingInputLine = props.inputLines[i];
                        return (<tr key={`${i}-service-line`}>
                            <td>{s.lineID}</td>
                            <td>{s.revCode}</td>
                            <td><div className="fixed-w-150">{s.procCode}</div></td>
                            <td>{s.modifier1}</td>
                            <td>{s.modifier2}</td>
                            <td>{matchingInputLine && matchingInputLine.serviceDate}</td>
                            <td>{s.units}</td>
                            <td>{s.adjUnits}</td>
                            <td>{formatStringAsCurrency(s.billed)}</td>
                            <td><div className="fixed-w-300">{s.serviceDescription}</div></td>
                            <td>{formatStringAsCurrency(s.allowedPriorToBilledCap)}</td>
                            <td>{formatStringAsCurrency(s.medicareAllowed)}</td>
                            <td>{s.paymentSource}</td>
                            <td>{s.finalAPC}</td>
                            <td>{s.apcStatusIndicator}</td>
                            <td>{s.bundledFlag}</td>
                            <td>{formatStringWithPrecision(s.modifierAdj, 2)}</td>
                            <td>{formatStringWithPrecision(s.multipleSurgeryAdj, 2)}</td>
                            <td>{s.manualAdjudicationFlag}</td>
                            <td>{s.errorFlag}</td>
                            <td><div className="fixed-w-300">{s.errorDescription}</div></td>
                            <td>{s.warningFlag}</td>
                            <td><div className="fixed-w-300">{s.warningDescription}</div></td>
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
        </>);
    }

    if (props.model === PFS) {
        return (<>
        <h4>Service Line Items</h4>
        <div className="table-responsive line-items">
            <table className="table">
                <thead>
                    <tr>
                        <td>Line ID</td>
                        <td>Procedure Code<br/>(CPT / HCPCS)</td>
                        <td>Modifier 1</td>
                        <td>Modifier 2</td>
                        <td>Service Date</td>
                        <td>Units</td>
                        <td>Adjusted Units</td>
                        <td>Billed</td>
                        <td>Service Description</td>
                        <td>Allowed Prior to Lesser of Billed</td>
                        <td>Medicare Allowed</td>
                        <td>Payment Source</td>
                        <td>Status Indicator</td>
                        <td>Bundled Flag</td>
                        <td>Anesthesia Flag</td>
                        <td>Practice Expense RVUs</td>
                        <td>Malpractice RVUs</td>
                        <td>Work RVUs</td>
                        <td>Modifier Adjustment</td>
                        <td>Multiple Surgery Adjustment</td>
                        <td>Manual Adjudication Flag</td>
                        <td>Error Flag</td>
                        <td>Error Description</td>
                        <td>Warning Flag</td>
                        <td style={{ minWidth: '150px' }}>Warning Description</td>
                    </tr>
                </thead>
                <tbody>
                    {props.result.services && props.result.services.map((s, i) => {
                        const matchingInputLine = props.inputLines[i];
                        return (<tr key={`${i}-service-line`}>
                            <td>{s.lineID}</td>
                            <td><div className="fixed-w-150">{s.procCode}</div></td>
                            <td>{s.modifier1}</td>
                            <td>{s.modifier2}</td>
                            <td>{matchingInputLine && matchingInputLine.serviceDate}</td>
                            <td>{s.units}</td>
                            <td>{s.adjUnits}</td>
                            <td>{formatStringAsCurrency(s.billed)}</td>
                            <td><div className="fixed-w-300">{s.serviceDescription}</div></td>
                            <td>{formatStringAsCurrency(s.allowedPriorToBilledCap)}</td>
                            <td>{formatStringAsCurrency(s.medicareAllowed)}</td>
                            <td>{s.paymentSource}</td>
                            <td>{s.medicareStatusLookup}</td>
                            <td>{s.bundledFlag}</td>
                            <td>{s.anesthesiaFlag}</td>
                            <td>{formatStringWithPrecision(s.pervUs, 2)}</td>
                            <td>{formatStringWithPrecision(s.mprvUs, 2)}</td>
                            <td>{formatStringWithPrecision(s.workRVUs, 2)}</td>
                            <td>{formatStringWithPrecision(s.modifierAdj, 2)}</td>
                            <td>{formatStringWithPrecision(s.multipleSurgeryAdj, 2)}</td>
                            <td>{s.manualAdjudicationFlag}</td>
                            <td>{s.errorFlag}</td>
                            <td><div className="fixed-w-200">{s.errorDescription}</div></td>
                            <td>{s.warningFlag}</td>
                            <td><div className="fixed-w-200">{s.warningDescription}</div></td>
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
        </>);
    }

    if (props.model === ESRD) {
        return (<>
        <h4>Service Line Items</h4>
        <div className="table-responsive line-items">
            <table className="table">
                <thead>
                    <tr>
                        <td>Line ID</td>
                        <td>Revenue Code</td>
                        <td>Procedure Code<br/>(CPT / HCPCS)</td>
                        <td>NDC</td>
                        <td>Modifier 1</td>
                        <td>Modifier 2</td>
                        <td>Dialysis Code Type</td>
                        <td>Service Date</td>
                        <td>Units</td>
                        <td>Billed</td>
                        <td>Revenue Code Description</td>
                        <td>HCPCS Code Description</td>
                        <td>Medicare Allowed</td>
                        <td>Outlier MAP (Medicare Allowed Pmt)</td>
                        <td>Error Flag</td>
                        <td>Error Description</td>
                        <td>Warning Flag</td>
                        <td>Warning Description</td>
                    </tr>
                </thead>
                <tbody>
                    {props.result.services && props.result.services.map((s, i) => {
                        const matchingInputLine = props.inputLines[i];
                        return (<tr key={`${i}-service-line`}>
                            <td>{s.lineID}</td>
                            <td>{s.revCode}</td>
                            <td><div className="fixed-w-150">{s.procCode}</div></td>
                            <td>{s.ndc}</td>
                            <td>{s.modifier1}</td>
                            <td>{s.modifier2}</td>
                            <td>{s.dialysisCodeType}</td>
                            <td>{matchingInputLine && matchingInputLine.serviceDate}</td>
                            <td>{s.units}</td>
                            <td>{formatStringAsCurrency(s.billed)}</td>
                            <td><div className="fixed-w-300">{s.revCodeDescription}</div></td>
                            <td><div className="fixed-w-300">{s.procCodeDescription}</div></td>
                            <td>{formatStringAsCurrency(s.medicareAllowed)}</td>
                            <td>{formatStringAsCurrency(s.outlierMAP)}</td>
                            <td>{s.errorFlag}</td>
                            <td><div className="fixed-w-300">{s.errorDescription}</div></td>
                            <td>{s.warningFlag}</td>
                            <td><div className="fixed-w-300">{s.warningDescription}</div></td>
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
        </>);
    }

    if (props.model === HH) {
        const resultsByPossibleRev = [
            {revCode:'Physical Therapy - 042x', visits : props.result.visitsPT, units : props.result.unitsPT,lupaPayment:props.result.lupaPmtPT,estimatedCostOfCare:props.result.estCostOfCarePT},
            {revCode:'Occupational Therapy - 043x', visits : props.result.visitsOT, units : props.result.unitsOT,lupaPayment:props.result.lupaPmtOT,estimatedCostOfCare:props.result.estCostOfCareOT},
            {revCode:'Speech Language Pathology - 044x', visits : props.result.visitsSLP, units : props.result.unitsSLP,lupaPayment:props.result.lupaPmtSLP,estimatedCostOfCare:props.result.estCostOfCareSLP},
            {revCode:'Skilled Nursing - 055x', visits : props.result.visitsSN, units : props.result.unitsSN,lupaPayment:props.result.lupaPmtSN,estimatedCostOfCare:props.result.estCostOfCareSN},
            {revCode:'Medical Social Services - 056x', visits : props.result.visitsMSS, units : props.result.unitsMSS,lupaPayment:props.result.lupaPmtMSS,estimatedCostOfCare:props.result.estCostOfCareMSS},
            {revCode:'Home Health - 057x', visits : props.result.visitsHH, units : props.result.unitsHH,lupaPayment:props.result.lupaPmtHH,estimatedCostOfCare:props.result.estCostOfCareHH}
        ];

        return (<>
            <h4>Revenue Code Detail</h4>
            <div className="fst-italic">These values are not payments, but feed into the LUPA and high-cost outlier calculations</div>
            <div className="table-responsive line-items">
                <table className="table">
                    <thead>
                        <tr>
                            <td>Revenue Code</td>
                            <td className='text-center'>Visits</td>
                            <td className='text-center'>Units</td>
                            <td className='text-center'>LUPA Payment (Incl. Add-On)</td>
                            <td className='text-center'>Estimated Cost of Care</td>
                        </tr>
                    </thead>
                    <tbody>
                        {resultsByPossibleRev.map((prc, i) => {
                            return (<tr key={`${i}-revenue-code`}>
                                <td>{prc.revCode}</td>
                                <td className='text-end'>{prc.visits}</td>
                                <td className='text-end'>{prc.units}</td>
                                <td className='text-end'>{formatStringAsCurrency(prc.lupaPayment || 0)}</td>
                                <td className='text-end'>{formatStringAsCurrency(prc.estimatedCostOfCare || 0)}</td>
                            </tr>);
                        })}
                    </tbody>
                </table>
            </div>
            </>);
    }

    
    if (props.model === SNF) {
        return (<>
        <h4>Service Line Items</h4>
        <div className="table-responsive line-items">
            <table className="table">
                <thead>
                    <tr>
                        <td>Assessment</td>
                        <td>HIPPS Code</td>
                        <td>Days</td>
                        <td>Medicare Allowed by Line</td>
                        <td>PT Payment</td>
                        <td>OT Payment</td>
                        <td>SLP Payment</td>
                        <td>Nursing Payment</td>
                        <td>NTA Payment</td>
                        <td>Non-Case Mix Payment</td>
                        <td>VBP Payment Difference</td>
                    </tr>
                </thead>
                <tbody>
                    {props.result.services && props.result.services.map((s, i) => {
                        return (<tr key={`${i}-service-line`}>
                            <td>{i+1}</td>
                            <td><div className="fixed-w-150">{s.hcpcs}</div></td>
                            <td>{s.unitsDays}</td>
                            <td>{formatStringAsCurrency(s.hippsPayment)}</td>
                            <td>{formatStringAsCurrency(s.ptPayment)}</td>
                            <td>{formatStringAsCurrency(s.otPayment)}</td>
                            <td>{formatStringAsCurrency(s.slpPayment)}</td>
                            <td>{formatStringAsCurrency(s.nursingPayment)}</td>
                            <td>{formatStringAsCurrency(s.ntaPayment)}</td>
                            <td>{formatStringAsCurrency(s.nonCaseMixPayment)}</td>
                            <td>{formatStringAsCurrency(s.vbpPayment)}</td>
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
        </>);
    }

    if (props.model === FQHC) {
        return (<>
        <h4>Service Line Items</h4>
        <div className="table-responsive line-items">
            <table className="table">
                <thead>
                    <tr>
                        <td>Line Number</td>
                        <td>GAF Applies</td>
                        <td>HCPCS</td>
                        <td>Billed</td>
                        <td>Rev Code</td>
                        <td>Medicare Allowed</td>
                        <td>New Patient Adjustment Factor</td>
                        <td>New Patient Adjustment Factor Applies</td>
                    </tr>
                </thead>
                <tbody>
                    {props.result.lines && props.result.lines.map((s, i) => {
                        return (<tr key={`${i}-service-line`}>
                            <td>{s.lineNumber}</td>
                            <td>{s.gafApplies.toString()}</td>
                            <td><div className="fixed-w-150">{s.hcpcs}</div></td>
                            <td>{formatStringAsCurrency(s.billed)}</td>
                            <td>{s.revCode}</td>
                            <td>{formatStringAsCurrency(s.medicareAllowed)}</td>
                            <td>{formatStringWithPrecision(s.newPatientAdjustmentFactor)}</td>
                            <td>{s.newPatientAdjustFactorApplies.toString()}</td>
                        </tr>);
                    })}
                </tbody>
            </table>
        </div>
        </>);
    }

    console.warn('Model unknown:', props.model);
    return null;
}